//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SfImage from "~/themes/fiskarsMoominDefault/components/components/atoms/SfImage/SfImage.vue";
import SfList from "~/themes/fiskarsMoominDefault/components/components/organisms/SfList/SfList.vue";
import SfBottomModal from "~/themes/fiskarsMoominDefault/components/components/molecules/SfBottomModal/SfBottomModal.vue";
import SfCharacteristic from "~/themes/fiskarsMoominDefault/components/components/molecules/SfCharacteristic/SfCharacteristic.vue";
import SfModal from "~/themes/fiskarsMoominDefault/components/components/molecules/SfModal/SfModal.vue";
import SfHeading from "~/themes/fiskarsMoominDefault/components/components/atoms/SfHeading/SfHeading.vue";
import { computed } from "@nuxtjs/composition-api";
import { useVSFContext } from "@vue-storefront/core";
import { useUiState } from "~/composables";
import { COOKIES } from "~/helpers/constants";

export default {
  components: {
    SfHeading,
    SfModal,
    SfImage,
    SfList,
    SfBottomModal,
    SfCharacteristic,
  },
  setup() {
    const {
      i18n,
      app: { $cookies },
      i18n: { locale, locales, localeProperties },
      $config,
    } = useVSFContext();

    const { isCountrySelectorOpen, toggleCountrySelectorModal } = useUiState();

    const TITLE = i18n.t("LOCALE_SELECTOR.TITLE");
    const SELECTED_COUNTRY_LABEL = i18n.t(
      "LOCALE_SELECTOR.SELECTED_COUNTRY_LABEL"
    );

    const setCookieLocale = (locale, isExternal = false) => {
      if (isExternal) {
        window.open(locale.externalUrl, "_blank");
        return;
      }

      if (locale.code === "int") {
        $cookies.set(COOKIES.MCRCCODE, locale.countryCode, {
          maxAge: 60 * 60 * 24 * 15,
          path: "/", // Cookie path
        });

        $cookies.set(COOKIES.MCRCNTRY, locale.country, {
          maxAge: 60 * 60 * 24 * 15,
          path: "/", // Cookie path
        });
      }

      const href = returnHref(locale);
      window.location.href = href;
    };

    const _selectedLocale = computed(() =>
      locales?.find(
        (language) => language.baseStoreCode === localeProperties.baseStoreCode
      )
    );

    const JAPAN_LOCALE = {
      code: "ja-jp",
      countryCode: "jp",
      country: "Japan",
      continent: "Asia",
      baseStoreCode: "jp",
      externalUrl: "https://www.moominarabia.jp/",
    };
    const _groupedLocales = computed(() => {
      const result = [];
      const currentLocale = localeProperties.code;

      locales.forEach((country) => {
        // Check if the locale should be included
        const isEnLocale = country.code === 'en-us'; // enable when introduct new locale with restriction
        const shouldInclude =
          !isEnLocale || (isEnLocale && currentLocale === "");

        if (shouldInclude) {
          let continentObj = result.find(
            (item) => item.continent === country.continent
          );

          if (!continentObj) {
            continentObj = { continent: country.continent, countries: [] };
            result.push(continentObj);
          }

          continentObj.countries.push(country);
        }
      });

      // Add hardcoded item for continent "Asia" and country-code "jp"
      let asiaContinent = result.find((item) => item.continent === "Asia");
      if (!asiaContinent) {
        asiaContinent = { continent: "Asia", countries: [] };
        result.push(asiaContinent);
      }
      asiaContinent.countries.push(JAPAN_LOCALE);

      return result;
    });

    const returnTarget = (lang) => {
      return lang.externalUrl ? "_blank" : "_self";
    };

    const returnHref = (lang) => {
      return lang.externalUrl
        ? lang.externalUrl
        : $config.productionURL + "/" + lang.code + "/";
    };

    const returnCountryLabel = (lang) => {
      return i18n.t("LOCALE_SELECTOR.COUNTRY_LABEL").replace('{0}', lang);
    };

    return {
      i18n,
      TITLE,
      SELECTED_COUNTRY_LABEL,
      _groupedLocales,
      locale,
      localeProperties,
      _selectedLocale,
      isCountrySelectorOpen,
      toggleCountrySelectorModal,
      setCookieLocale,
      returnTarget,
      returnHref,
      returnCountryLabel
    };
  },
};
